import React, { useState, useEffect } from 'react';
import './BlogTableOfContents.css';

const BlogTableOfContents = () => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    // Collect all h2 and h3 elements in the blog post
    const elements = Array.from(document.querySelectorAll('.post-content h2, .post-content h3'));
    
    // Process headings for TOC
    const headingElements = elements.map(element => {
      // Create an id from the heading text if one doesn't exist
      if (!element.id) {
        const id = element.textContent
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-');
        element.id = id;
      }
      
      return {
        id: element.id,
        text: element.textContent,
        level: element.tagName === 'H2' ? 2 : 3
      };
    });
    
    setHeadings(headingElements);
  }, []);

  return (
    <div className="blog-toc">
      <h3 className="blog-toc-title">Table of Contents</h3>
      <nav className="blog-toc-links">
        {headings.map(heading => (
          <a
            key={heading.id}
            href={`#${heading.id}`}
            className={`blog-toc-link level-${heading.level}`}
          >
            {heading.text}
          </a>
        ))}
      </nav>
    </div>
  );
};

export default BlogTableOfContents;
